import addRecipientToRecipientWell from 'owa-recipient-common/lib/actions/addRecipientToRecipientWell';
import { action } from 'satcheljs/lib/legacy';
export default action('addSelectedRecipientToWell')(function addSelectedRecipientToWell(viewState, targetRecipientWell, newPersona) {
    if (newPersona === void 0) { newPersona = null; }
    if (!newPersona) {
        newPersona = viewState.recipientsShown[viewState.selectedRecipientIndex];
    }
    var newRecipient = {
        persona: newPersona,
        displayText: newPersona.EmailAddress.Name
            ? newPersona.EmailAddress.Name
            : newPersona.EmailAddress.EmailAddress,
        isValid: true,
        isContextMenuOpen: false,
        isSelected: false,
        isExpanding: false,
    };
    addRecipientToRecipientWell(newRecipient, targetRecipientWell);
});
//# sourceMappingURL=addSelectedRecipientToWell.js.map